import { useState } from "react";
import { useGoogleLogin } from '@react-oauth/google';
import { trackEvent, identifyUser } from '../utils/analytics';

const Confirmation = ({ email, setEmail, startChatbotCreation, websiteUrl, isLoading, submitError }) => {
  const [error, setError] = useState('');

  const isValidEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

  const handleSubmit = () => {
    if (!isValidEmail(email)) {
      setError('Invalid email. Please enter a valid email address');
      trackEvent('Form Error Displayed', {
        error_type: 'invalid_email',
        error_message: 'Invalid email. Please enter a valid Email address',
        field_name: 'email'
      }, { email, websiteUrl });
      return;
    }
    identifyUser(email, { websiteUrl });
    trackEvent('Email Captured', { capture_method: 'manual' }, { email, websiteUrl });
    startChatbotCreation();
  };

  const handleGoogleSuccess = async (credentials_response) => {
    const token = credentials_response.access_token;
    let response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
      headers: { Authorization: `Bearer ${token}` },
    });
    let json = await response.json();
    if (json.email) {
      setEmail(json.email);
      identifyUser(json.email, { websiteUrl });
      trackEvent('Email Captured', { capture_method: 'google' }, { email: json.email, websiteUrl });
    }
  };

  const login = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      trackEvent('OAuth Login Initiated', { oauth_provider: 'google' }, { email, websiteUrl });
      handleGoogleSuccess(tokenResponse);
    },
  });

  return (
    <div className="ec-card">
      <h2 className="ec-headline">Where can we send your AI?</h2>
      <div className="ec-input-row">
        <input
          type="email"
          className="ec-input"
          placeholder="Your email"
          autoComplete="email"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setError(''); }}
          onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
        />
        <button className="ec-cta" onClick={handleSubmit} disabled={isLoading}>
          {isLoading ? 'Sending…' : 'Send ›'}
        </button>
      </div>
      {error && <p className="ec-error">{error}</p>}
      {submitError && <p className="ec-error">{submitError}</p>}
      <p className="ec-microcopy">
        <a href="https://customgpt.ai/privacy-policy/" className="ec-privacy-link">Privacy policy</a>
      </p>
      <div className="ec-divider"><span>Or</span></div>
      <button type="button" className="ec-google-btn" onClick={login}>
        <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.258h2.908C16.658 14.121 17.64 11.813 17.64 9.205z" fill="#4285F4"/>
          <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
          <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.997 8.997 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
          <path d="M9 3.58c1.321 0 2.508.454 3.44 1.346l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
        </svg>
        Auto-fill with Google
      </button>
    </div>
  );
};

export default Confirmation;
